import { z } from 'zod';
// ─── Auth ────────────────────────────────────────────────────────
export const LoginSchema = z.object({
    email: z.string().email('Nieprawidłowy adres email'),
    password: z.string().min(8, 'Hasło musi mieć min. 8 znaków'),
});
export const PasswordResetRequestSchema = z.object({
    email: z.string().email(),
});
export const PasswordResetConfirmSchema = z.object({
    token: z.string().min(32),
    newPassword: z.string().min(8),
});
// ─── Work sessions ───────────────────────────────────────────────
/** GPS przy clock-in/out — wymagane od pracownika (hard block) */
export const GpsCoordsSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    accuracyM: z.number().positive(),
});
export const StartSessionSchema = z.object({
    /** Client-side UUID dla idempotencji offline queue */
    clientEventId: z.string().uuid(),
    /** Moment kliknięcia po stronie klienta (ISO 8601, UTC) */
    clientTimestamp: z.string().datetime(),
    gps: GpsCoordsSchema,
});
export const EndSessionSchema = z.object({
    sessionId: z.string().min(1),
    clientEventId: z.string().uuid(),
    clientTimestamp: z.string().datetime(),
    gps: GpsCoordsSchema,
});
// ─── Admin: korekta sesji ────────────────────────────────────────
export const AdminCorrectSessionSchema = z.object({
    sessionId: z.string().min(1),
    startedAt: z.string().datetime().optional(),
    endedAt: z.string().datetime().nullable().optional(),
    notes: z.string().min(1, 'Notatka jest wymagana przy korekcie'),
});
export const AdminAddSessionSchema = z.object({
    userId: z.string().min(1),
    startedAt: z.string().datetime(),
    endedAt: z.string().datetime().nullable(),
    notes: z.string().min(1),
});
// ─── Admin: użytkownicy ──────────────────────────────────────────
export const RoleSchema = z.enum(['EMPLOYEE', 'ADMIN']);
export const CreateUserSchema = z.object({
    email: z.string().email(),
    name: z.string().min(2),
    role: RoleSchema,
    vacationDaysPerYear: z.number().int().min(0).max(60).default(26),
});
export const UpdateUserSchema = CreateUserSchema.partial().extend({
    active: z.boolean().optional(),
});
// ─── Admin: urlopy ───────────────────────────────────────────────
export const SetVacationBalanceSchema = z.object({
    userId: z.string().min(1),
    year: z.number().int().min(2024).max(2100),
    totalDays: z.number().int().min(0).max(60),
});
//# sourceMappingURL=schemas.js.map